import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ListGroupItem } from 'reactstrap';
import { useFeatures } from '@cordata/buffet';

import { authorizedPyInstance as py } from '~/utils';
import usePatient from '~/utils/patient/hook';
import { LoadingModal } from '~/components';

const FormDownloadsButton = ({ displayFormButton, displayHospitalRegistrationSheet }) => {
  const [, { id }, actions] = usePatient();
  const { isIdentityHealthcareUser } = useFeatures();

  const [link, setLink] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCanceled, setIsCanceled] = useState(false);

  const downloadHospitalRegistrationForm = () => {
    setIsModalOpen(true);
    setIsCanceled(false);

    py
      .get(`/api/data/public/identity/patient/${id}/hospital-registration-sheet`)
      .then((r) => {
        setLink(r.data.data.link);

        actions.audit('HospitalRegistrationSheet');
      })
      .finally(() => {
        setIsModalOpen(false);
      });
  };

  const downloadChildHealthForm = () => {
    setIsModalOpen(true);
    setIsCanceled(false);

    py
      .get(`/api/data/public/identity/patient/${id}/child-health-form`)
      .then((r) => {
        setLink(r.data.data.link);

        actions.audit('ChildHealthForm');
      })
      .finally(() => {
        setIsModalOpen(false);
      });
  };

  const cancelDownload = () => {
    setIsModalOpen(false);
    setIsCanceled(true);
  };

  useEffect(() => {
    if (link && !isCanceled) {
      window.open(link, '_blank');
    }
  }, [link]);

  return (
    <>
      {!!displayFormButton && (
        <ListGroupItem
          onClick={downloadChildHealthForm}
          className="d-flex align-items-center border-dark side-nav-item"
        >
          Child&apos;s Health Information Form
        </ListGroupItem>
      )}

      {isIdentityHealthcareUser && displayHospitalRegistrationSheet && (
        <ListGroupItem
          onClick={downloadHospitalRegistrationForm}
          className="d-flex align-items-center border-dark side-nav-item"
        >
          Hospital Registration Sheet
        </ListGroupItem>
      )}

      <LoadingModal
        isOpen={isModalOpen}
        toggle={cancelDownload}
        headerText="Downloading..."
        message="Please wait as we prepare the file for download."
      />
    </>
  );
};

FormDownloadsButton.propTypes = {
  displayFormButton: PropTypes.bool,
  displayHospitalRegistrationSheet: PropTypes.bool,
};

FormDownloadsButton.defaultProps = {
  displayFormButton: true,
  displayHospitalRegistrationSheet: true,
};

export default FormDownloadsButton;
